import React from 'react';
import { useForm } from 'react-hook-form';
import FormText from '../../../components/FormText/FormText';
import { FORM_TEXT_COMPONENT_TYPES, FORM_TEXT_TYPES } from '../../../components/FormText/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import { replaceVariables } from '../../../utils';

const FormAddPetName = () => {
  const { register, handleSubmit, reset, formState } = useForm();
  const newPet = vars.newPet();
  const type = FORM_TEXT_TYPES.CREATE_PET;
  const { title, registerAs, placeholder } = FORM_TEXT_COMPONENT_TYPES[type];
  const onSubmit = (data: Record<string, string>) => {
    vars.newPet({ ...newPet, name: data[registerAs] });
    increaseFormPage();
  };

  return (
    <FormText
      type={type}
      formOptions={{ register, handleSubmit, reset, formState }}
      onSubmit={onSubmit}
      title={replaceVariables(title, { petType: newPet?.type?.toLowerCase() })}
      placeholder={replaceVariables(placeholder, {
        petType: newPet?.type?.toLowerCase()
      })}
    />
  );
};
export default FormAddPetName;
